var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('div',{staticClass:"header__bg"},[_c('BaseBannerTitle',{attrs:{"title":"方案價格","sub-title":"Pricing"}})],1),_c('SectionPlan'),_c('SectionContact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }